import React from "react";
import { withRouter } from "react-router-dom";

const Back = ({ history }) =>
  history.length > 1 && (
  	<a onClick={history.goBack} className="back-button">
			<span className="fa-stack fa-lg">
			  <i className="fa fa-circle fa-stack-2x"></i>
			  <i className="fa fa-angle-left fa-stack-1x fa-inverse"></i>
			</span>
		</a>
  );

export default withRouter(Back);



// WEBPACK FOOTER //
// ./src/components/Back.js